export default __webpack_public_path__ + "static/media/finish-tumbled.24bf777e.jpg";